import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { SignInForm } from '~/components/refineUi/form/signInForm'

export function LoginPage() {
  const [searchParams, setSearchParams] = useSearchParams()

  // Refine's `useLogin` follows a raw `?to=` after sign-in, bypassing the
  // sanitized `returnTo` (see `providers/authProvider.ts`): drop it
  useEffect(() => {
    if (searchParams.has('to')) {
      setSearchParams(
        (params) => {
          params.delete('to')
          return params
        },
        { replace: true },
      )
    }
  }, [searchParams, setSearchParams])

  return <SignInForm />
}
